import { AddCompanyEffects } from './add-company.effect';
import { RemoveCompanyEffects } from './remove-company.effect';
import { SaveCompanyEffects } from './save-company.effect';
import { SearchCompanyEffects } from './search-company.effect';
import { SelectCompanyEffects } from './select-company.effect';
import { UserCompaniesEffects } from './user-companies.effect';

export const effects: any[] = [
  SearchCompanyEffects,
  AddCompanyEffects,
  SaveCompanyEffects,
  SelectCompanyEffects,
  UserCompaniesEffects,
  RemoveCompanyEffects,
];
